import React from 'react';
import { useLocation, Link } from 'react-router-dom';

/**
 * NotFound — Page 404 (Sprint Frontend B5).
 *
 * Remplace le NotFoundPlaceholder de A5/App.js. Affiche l'URL demandée
 * et propose un retour à l'accueil (qui redirige selon auth via RootRedirect).
 */
export default function NotFound() {
  const location = useLocation();
  return (
    <div style={{
      padding: 40,
      fontFamily: 'system-ui, sans-serif',
      textAlign: 'center',
      maxWidth: 600,
      margin: '80px auto',
    }}>
      <h1 style={{ color: '#5A3C1F', fontSize: 32 }}>404 — Page introuvable</h1>
      <p style={{ color: '#6B5847', marginBottom: 8 }}>L'URL demandée n'existe pas :</p>
      <code style={{
        display: 'inline-block',
        padding: '4px 12px',
        background: '#F5EFE6',
        borderRadius: 4,
        color: '#A0763E',
        fontSize: 14,
        marginBottom: 24,
      }}>
        {location.pathname}
      </code>
      <div>
        <Link to="/" style={{
          color: '#A0763E',
          textDecoration: 'none',
          fontWeight: 600,
          padding: '12px 24px',
          border: '2px solid #A0763E',
          borderRadius: 8,
          display: 'inline-block',
        }}>
          Retour à l'accueil
        </Link>
      </div>
    </div>
  );
}
